var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"nav__items",class:{ 'is-active' : _vm.active },on:{"click":function($event){return _vm.setGroupName(_vm.group)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }